<template>
  <div class="reset-password">
    <div class="row">
      <div class="col-md-12">
        <form
          method="POST"
          action="/"
        >
          <div
            class="form-group row"
            :class="{'has-error' : validations['old_password'] }"
          >
            <label
              for="email"
              class="col-md-4 col-form-label text-md-right"
            >{{ $t('label.oldPassword') }}</label>
            <div class="col-md-6">
              <input
                id="email"
                type="password"
                v-model="user.old_password"
                :placeholder="$t('label.oldPassword')"
                class="form-control"
                name="email"
                autofocus
              >
              <template v-if="validations['old_password']">
                <span
                  class="help-block"
                  role="alert"
                >
                  <strong>{{ validations['old_password'][0] }}</strong>
                </span>
              </template>
            </div>
          </div>

          <div
            class="form-group row"
            :class="{'has-error' : validations['password']}"
          >
            <label
              for="password"
              class="col-md-4 col-form-label text-md-right"
            >{{ $t('label.password') }}</label>
            <div class="col-md-6">
              <input
                id="password"
                type="password"
                v-model="user.password"
                :placeholder="$t('label.password')"
                class="form-control"
                name="password"
              >
              <template v-if="validations['password']">
                <span
                  class="help-block"
                  role="alert"
                >
                  <strong>{{ validations['password'][0] }}</strong>
                </span>
              </template>
            </div>
          </div>

          <div
            class="form-group row"
            :class="{' has-error' : validations['password']}"
          >
            <label
              for="password-confirm"
              class="col-md-4 col-form-label text-md-right"
            >{{ $t('label.confirmPassword') }}</label>
            <div class="col-md-6">
              <input
                id="password-confirm"
                v-model="user.password_confirmation"
                type="password"
                :placeholder="$t('label.confirmPassword')"
                class="form-control"
                name="password_confirmation"
              >
              <template v-if="validations['password']">
                <span
                  class="help-block"
                  role="alert"
                >
                  <strong>{{ validations['password'][0] }}</strong>
                </span>
              </template>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-4" />
            <div class="col-md-6">
              <button
                type="submit"
                @click="resetPassword"
                class="btn btn-primary"
              >
                {{ $t('button.resetPassword') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ResetPassword',
  data () {
    return {
      user: {
        password: '',
        old_password: '',
        password_confirmation: ''
      },
      validations: {}
    }
  },
  methods: {
    resetPassword (e) {
      this.validations = {}
      e.preventDefault()
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/auth/backend/reset-password ', this.user)
        .then(({ data }) => {
          if (data.data) {
            const { access_token, refresh_token } = data.data
            // set access_token and refresh_token into localstorage
            localStorage.setItem(process.env.VUE_APP_TOKEN, access_token)
            localStorage.setItem(process.env.VUE_APP_REFRESH_TOKEN, refresh_token)
            // set headers
            this.$axios.defaults.headers.common.Authorization = 'Bearer ' + access_token
            this.$axios.defaults.headers.common.Accept = 'application/json'
            // set ajax request headers
            $.ajaxSetup({
              headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + access_token
              }
            })
            this.$router.push({ name: 'dashboard' })
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    }
  }
}
</script>

<style scoped>
.reset-password {
  padding: 10px;
}

.text-md-right {
  text-align: right;
}
</style>
